import { render, staticRenderFns } from "./IptNumber.vue?vue&type=template&id=5e3c7384&scoped=true&"
import script from "./IptNumber.vue?vue&type=script&lang=js&"
export * from "./IptNumber.vue?vue&type=script&lang=js&"
import style0 from "./IptNumber.vue?vue&type=style&index=0&id=5e3c7384&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3c7384",
  null
  
)

export default component.exports